import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

// LearningPath query for all data needed for calendar

export const query = graphql(`
    query AppCalendarQuery {
        currentPerson {
            id
            calendarShowStartDate
            calendarShowFinished
            learningPaths(filter: "ongoing") {
                id
                pathname
                learningPathItems {
                    id
                    type
                    event {
                        id
                        shortTitle
                        eventStart
                        eventEnd
                        url
                    }
                    feedbackTask {
                        id
                        shortTitle
                        callToAction
                        deadline
                        miles
                        url
                        submittedFeedbackTask {
                            id
                            status
                        }
                    }
                    tasks {
                        id
                        url
                        miles
                        shortTitle
                        callToAction
                        deadline
                        unlockDate
                        timeEstimate
                        taskVariants {
                            id
                            variantType
                            eventStart
                            eventEnd
                        }
                        submittedTask {
                            id
                            status
                        }
                    }
                    taskChoice {
                        id
                        url
                        name
                        unlockDate
                        callToAction
                        deadline
                        complete
                    }
                }
            }
        }
    }
`);

export type IData = ResultOf<typeof query>;

export const perfsMutation = graphql(`
    mutation AppCalendarPerfsMutation($data: PlayerCurrentPersonCalendarPrefsData!) {
        currentPersonUpdateCalendarPerfs(data: $data) {
            currentPerson {
                id
                calendarShowStartDate
                calendarShowFinished
            }
            error
        }
    }
`);
